import { Box, CircularProgress } from '@mui/material'
import PageWrapper from 'hoc/PageWrapper'
import { FunctionComponent } from 'react'

interface Props {
  fullPage?: boolean
}

export const Loading: FunctionComponent<Props> = ({ fullPage = true }) => {
  if (fullPage)
    return (
      <PageWrapper>
        <LoadingElement />
      </PageWrapper>
    )

  return <LoadingElement />
}

const LoadingElement = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" width="100%">
      <CircularProgress />
    </Box>
  )
}
